export type PublicStoreStatus = {
  ordersOpen: boolean
  wording: string
  subtext: string | null
  timeZone: 'Pacific/Auckland'
}

export function validPublicStoreStatus(value: unknown): value is PublicStoreStatus {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return false
  const record = value as Record<string, unknown>
  return typeof record.ordersOpen === 'boolean'
    && typeof record.wording === 'string'
    && (record.subtext === null || typeof record.subtext === 'string')
    && record.timeZone === 'Pacific/Auckland'
}
